import React, { useEffect, useState } from 'react';
import { dateFormatter } from 'bog-arcade-core-ui/helpers';
import { amountFormatter } from 'bog-arcade-core-ui/helpers';

import { PopupHeader } from '../popup/popupHeader';
import { DataTable } from '../dataTable/DataTable';
import { DataTableHead } from '../dataTable/helpers/DataTableHead';
import { TKeys, translationKeys } from '../../core/translation/translation';
import { useTranslation } from '../../core/translation/useTranslation';
import { HISTORY_ICON_STATE, HISTORY_LIST } from '../../stateManagment';
import { partnerService } from '../../services/helperServices/PartnerService';

import checkedIcon from '../../assets/checked_icon.svg';

import './gameHistoryPopup.css';
import { getAmount } from '../../core/helpers/getAmount';

const getHeads = (t) =>  [
  new DataTableHead({
    title: t(TKeys.Time),
    name: 'time',
    render: (self) => (<div>
      {self.title}
    </div>),
  }),
  new DataTableHead({
    title: t(TKeys.Bet),
    name: 'bet',
    render: (self) => (<div>
      {self.title}
    </div>),
  }),
  new DataTableHead({
    title: t(TKeys.WinOdd),
    name: 'betType',
    render: (self) => (<div>
      {self.title}
    </div>),
  }),
  new DataTableHead({
    title: t(TKeys.Win),
    name: 'win',
    render: (self) => (<div>
      {self.title}
    </div>),
  }),
  new DataTableHead({
    title: t(TKeys.Bonus),
    name: 'bonus',
    render: (self) => (<div>
      {self.title}
    </div>),
  }),
];

const bodyMap = {
  time: data => dateFormatter.format(data.time),
  bet: data => `${getAmount(data.betAmount)}`,
  betType: data => `${data.odd}x`,
  win: data => data.winAmount ? `${amountFormatter.format(data.winAmount)} ${partnerService.displayCurrency}` : 'No Win',
  bonus: data => data.bonus ? (
    <div className="game-history-popup_bonus">
      <img
        className="game-history-popup_bonus-icon"
        src={checkedIcon}
        alt="checkedIcon"
      />
    </div>
  ) : <span>-</span>,
};

export const GameHistoryPopup = () => {
  const [history, setHistory] = useState(HISTORY_LIST.getValue());

  const t = useTranslation();

  useEffect(() => {
    const historyObserver = HISTORY_LIST.subscribe(setHistory);
    return () => {
      historyObserver.unsubscribe();
    };
  }, []);

  const headsData = getHeads(t)

  return (
    <section className="game-history-popup-content">
      <PopupHeader
        onClose={() => HISTORY_ICON_STATE.next(false)}
        title={translationKeys.history}
      />
      <DataTable
        heads={headsData}
        bodyMap={bodyMap}
        data={history}
      />
    </section>
  );
};
